import { dealerSortDuck } from '../ducks';

export default function setSortFromQuery() {
    return async (ctx) => {
        ctx.store.dispatch(
            dealerSortDuck.creators.setSort(ctx.query.sortBy ? ctx.query.sortBy : '')
        );
    };
}
